/**
 * Selectors for parent elements that wrap form controls
 */
export const PARENT_SELECTORS = '.wpcf7-form-control-wrap, .password-input, .woo-form-control-wrap';
